import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Guernsey: Country = {
    identifier: "Guernsey",
    name: "Guernsey",
    countryCode: "GG",
    group: CountryGroup.EUROPE,
    isUNMember: false,
    flag: "🇬🇬",
    svgPath: "m 467.84475,303.4184 -0.099,0.284 -0.257,-0.096 -0.02,-0.074 0.292,-0.165 0.06,0.001 z",
}
